export default {"src":"/_next/static/media/Hamburger.b01ec7c7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};